'use client';

/**
 * App Router global error boundary.
 *
 * Catches render errors thrown above every route segment's `error.tsx`.
 * Must define its own <html> / <body> because it replaces the root layout.
 *
 * Docs: https://nextjs.org/docs/app/building-your-application/routing/error-handling#handling-global-errors
 */


import { useEffect } from 'react';
import NextError from 'next/error';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* `NextError` renders Next's built-in error page chrome. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
